import React, { useState, useEffect, forwardRef } from 'react';
import cx from 'classnames';
// external libraries
import ReactMapGL from 'react-map-gl';
// config
import { MAP_ACCESS_TOKEN, MAP_STYLE_URL, MAP_HEIGHT, MAP_WIDTH, DRAG_ROTATE, ATTRIBUTION_CONTROL, MIN_ZOOM, MAX_ZOOM, } from '../../config';
import { MarqueeSelect } from '../MarqueeSelect';
// component
import { Spinner } from '../../../';
export const StyledMap = forwardRef((props, ref) => {
    const [showSpinner, setShowSpinner] = useState(true);
    const [mapLoaded, setMapLoaded] = useState(false);
    const { width = MAP_WIDTH, height = MAP_HEIGHT, mapboxApiAccessToken = MAP_ACCESS_TOKEN, mapStyle = MAP_STYLE_URL, minZoom = MIN_ZOOM, maxZoom = MAX_ZOOM, viewport, onViewportChange, dragRotate = DRAG_ROTATE, onLoad, onClick, doubleClickZoom = false, onHover, onMouseMove, children, attributionControl = ATTRIBUTION_CONTROL, disableSpinner, isDarkmode = false, transformRequest = null, 
    // preserveDrawingBuffer = true allows you to take screenshot of map which means WebGL has to flush the pipeline between frames
    // warning: set to false once screen capture job is done or it will hurt performance
    preserveDrawingBuffer = false, marqueeSelect = false, getSelectionBounds, isLoading, } = props;
    // click handler to satisfy correct typing - conversion between map event and mouse event
    const clickHandler = (e) => {
        if (onClick) {
            const typedEvent = e;
            onClick(typedEvent);
        }
    };
    // mouse move handler to satisfy correct typing - conversion between map event and mouse event
    const mouseMoveHandler = (e) => {
        if (onMouseMove) {
            const typedEvent = e;
            onMouseMove(typedEvent);
        }
    };
    const handleSpinnerRender = () => {
        if (disableSpinner !== true) {
            if (showSpinner || isLoading) {
                return (React.createElement(Spinner, { loading: true, className: cx('map-spinner', { 'map-spinner--transparent': mapLoaded }), size: "xl", centered: true }));
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    };
    // hide spinner after load
    useEffect(() => {
        if (mapLoaded && showSpinner) {
            setTimeout(() => {
                setShowSpinner(false); // remove after delay to blur out
                if (onLoad) {
                    onLoad();
                }
            }, 250);
        }
    }, [mapLoaded]);
    useEffect(() => {
        setMapLoaded(false);
    }, []);
    const [dragRotateStatus, setDragRotateStatus] = useState(dragRotate);
    return (React.createElement(ReactMapGL, Object.assign({}, viewport, { minZoom: minZoom, maxZoom: maxZoom, ref: ref, width: width, height: height, onViewportChange: onViewportChange, mapStyle: mapStyle, mapboxApiAccessToken: mapboxApiAccessToken, dragRotate: dragRotateStatus, onLoad: () => {
            setMapLoaded(true);
        }, onClick: clickHandler, onHover: onHover, onMouseMove: mouseMoveHandler, doubleClickZoom: doubleClickZoom, attributionControl: attributionControl, transformRequest: transformRequest, preserveDrawingBuffer: preserveDrawingBuffer }),
        React.createElement("div", { className: isDarkmode ? 'map-mode--dark' : 'map-mode--light' }, children),
        marqueeSelect && getSelectionBounds && (React.createElement(MarqueeSelect, { getSelectionBounds: getSelectionBounds, setDragRotateStatus: dragRotate ? setDragRotateStatus : null })),
        handleSpinnerRender()));
});
//# sourceMappingURL=StyledMap.js.map